import { ReloadOutlined } from '@ant-design/icons'
import { Button, Form, Select, Spin, Typography } from 'antd'
import { t } from 'i18next'
import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import useWorkspaceFolders from '../../../../../../hooks/useWorkspaceFolders'
import { SelectOption } from '../../../../../../types/generalTypes'
import { DelConfigurationModalInputStepProps } from './DelConfigurationModalInputStep'

const { Text } = Typography

const DelConfigurationModalTableAStep = ({
  form,
  setIsSelected,
}: DelConfigurationModalInputStepProps) => {
  const { workspaceId } = useParams()

  const {
    workspaceFiles,
    isWorkspaceFilesLoading,
    refreshWorkspaceFolders,
    parsePath,
  } = useWorkspaceFolders({
    workspaceId,
    preventFetch: true,
  })

  const options = useMemo(() => {
    if (!workspaceFiles || !workspaceFiles.length) {
      return []
    }
    return workspaceFiles.map((file) => ({
      label: parsePath(file.path),
      value: file.id,
    }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workspaceFiles])

  const refreshDocumentList = () => {
    setIsSelected(false)
    form.setFieldsValue({
      tableAComprehensiveFileId: undefined,
      tableAComprehensiveFileName: undefined,
      tableAHcFileId: undefined,
      tableAHcFileName: undefined,
    })

    refreshWorkspaceFolders()
  }

  const handleTableAHealthCanadaChange = (option: SelectOption) => {
    form.setFieldsValue({
      tableAHcFileId: option.value,
      tableAHcFileName: option.label,
    })
    checkSelection()
  }

  const handleTableAComprehensiveChange = (option: SelectOption) => {
    form.setFieldsValue({
      tableAComprehensiveFileId: option.value,
      tableAComprehensiveFileName: option.label,
    })
    checkSelection()
  }

  const checkSelection = () => {
    const tableAHCFileID = form.getFieldValue('tableAHcFileId')
    const tableAComprehensiveFileID = form.getFieldValue(
      'tableAComprehensiveFileId'
    )

    if (tableAHCFileID && tableAComprehensiveFileID) {
      setIsSelected(true)
    } else {
      setIsSelected(false)
    }
  }

  const filterOption = (input: string, option?: SelectOption) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())

  return (
    <>
      <Spin spinning={isWorkspaceFilesLoading}>
        <Form.Item
          name="dinFileId"
          label={t('delConfigurationModal.steps.tabelA.tableAFieldTitle')}
          rules={[
            {
              required: true,
              message: t('delConfigurationModal.documentsRequired'),
            },
          ]}
          extra={t(
            'delConfigurationModal.steps.tabelA.tabelAHealthCanadaLabel'
          )}
        >
          <Select
            labelInValue
            allowClear
            style={{ width: '100%' }}
            placeholder={t(
              'delConfigurationModal.steps.dinReview.dinFieldPlaceholder'
            )}
            onChange={handleTableAHealthCanadaChange}
            options={options}
            showSearch
            optionFilterProp="children"
            filterOption={filterOption}
          />
        </Form.Item>
        <Form.Item
          label={t('delConfigurationModal.steps.tabelA.tableAClientTitle')}
          name="dinClientFileId"
          rules={[
            {
              required: true,
              message: t('delConfigurationModal.documentsRequired'),
            },
          ]}
          extra={t('delConfigurationModal.steps.tabelA.tableAClientFeildLabel')}
        >
          <Select
            labelInValue
            allowClear
            style={{ width: '100%' }}
            placeholder={t('delConfigurationModal.steps.input.extra')}
            onChange={handleTableAComprehensiveChange}
            options={options}
            showSearch
            optionFilterProp="children"
            filterOption={filterOption}
          />
        </Form.Item>
      </Spin>
      <Text
        style={{
          paddingBottom: '10px',
        }}
      >
        {t('delConfigurationModal.steps.input.documentRefreshTitle')}
      </Text>
      <Button
        onClick={refreshDocumentList}
        icon={<ReloadOutlined />}
        block
        disabled={isWorkspaceFilesLoading}
      >
        {t('delConfigurationModal.steps.input.refreshDocuments')}
      </Button>
    </>
  )
}

export default DelConfigurationModalTableAStep
